import React from 'react'
import { useCronScheduleInvocations, useEstimatedCost } from './EstimatedCost.hooks'
import Typography from '@/components/ui/Typography'

export type EstimatedCostProps = { value: string | undefined }

export const EstimatedCost = ({ value }: EstimatedCostProps) => {
  const invocationsCount = useCronScheduleInvocations(value, 30)
  const [price, totalPrice, currency] = useEstimatedCost(value)
  const currencyLabel = currency === 'eur' ? 'EUR' : 'USD'

  return (
    <Typography variant={'caption'}>
      {`${invocationsCount} calls per month x ${price} ${currencyLabel} ≈ ${totalPrice} ${currencyLabel} per month`}
    </Typography>
  )
}
